import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-small-white-check",
  "use": "icon-small-white-check-usage",
  "viewBox": "0 0 8 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 8 6\" id=\"icon-small-white-check\">\n<style type=\"text/css\">\n\t#icon-small-white-check .st0{fill:#FFFFFF;}\n</style>\n<path class=\"st0\" d=\"M7.3,0.6C7,0.3,6.4,0.3,6.1,0.6l-3,3L1.8,2.4c-0.3-0.3-0.9-0.3-1.2,0c-0.3,0.3-0.3,0.9,0,1.2l1.9,1.9\n\tc0.2,0.2,0.4,0.2,0.6,0.2s0.4-0.1,0.6-0.2l3.6-3.6C7.6,1.5,7.6,0.9,7.3,0.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol